// removed by extract-text-webpack-plugin
module.exports = {"teacher_card":"_3DHtB8R0JKzJJFE_iH1mew","teacher_card_left":"_1fsZJZeewWr6bmpUMQ9sDS","teacher_card_avatar":"_2z5Umy4oWspkatcsZA781z","teacher_card_right":"_2dkiqxnP3CZyqOSiea2tkH"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/LecturePage/lecture-teachers.scss
// module id = 576
// module chunks = 0